import { stringify, parse } from '../misc.js';

export default function (...args)	// separator
{
	return {

		_separator: args[0] || ';',

		getValue(default_value, _this = this)
		{
			return parse(this.safeProtoCall(default_value, _this))?.map(entry => entry.trim());
		},

		setValue(value, _this = this)
		{
			this.safeProtoCall(stringify(Array.isArray(value) ? value : value?.split(this._separator) || []), _this);
		},

		checkValue(value = this.getValue())
		{
			return this.isEmpty() || value?.every(entry => Boolean(entry));
		},

		isEmpty(value = this.getValue())
		{
			return !value || (value.length == 1 && value[0] == '');
		},

		format(value = this.getValue(), mask = this.display_mask)
		{
			return (Array.isArray(value) ? value.join(`${this._separator} `) : value || '');
		},

	};
}

